(function() {
  if (window._fancygalleryLoaded) return;
  window._fancygalleryLoaded = true;

class FancyGallery extends HTMLElement {
  __init() {this.top = '133px';}
  constructor() {
    super();FancyGallery.prototype.__init.call(this);
    if (!gsap) return;
    const gazettePage = document.querySelector('#gazette-options');
    if (gazettePage) {
      setTimeout(() => {
        // wait for gazette to finish to avoid gsap form bombing out
        this.initializeAnimation();
      }, 1000);
    } else {
      this.initializeAnimation();
    }
  }

  initializeAnimation() {
    const mm = gsap.matchMedia();
    mm.add('(min-width: 750px)', this.desktopAnimation, this);
    mm.add('(max-width: 750px)', this.mobileAnimation, this);
  }

  desktopAnimation() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.fancy-gallery',
        start: () => 'top ' + document.querySelector('header.header').clientHeight + 'px',
        end: 'bottom -' + document.body.clientHeight + 'px',
        toggleAction: 'restart pause reverse pause',
        pin: true,
        scrub: 1.2,
      },
      smoothChildTiming: true,
    });

    tl.from('.fancy-gallery__item.main', {
      width: '100vw',
      duration: 2,
      ease: 'power1',
    });

    tl.to(
      '.content-overlay',
      {
        opacity: 1,
        duration: 1,
        transform: 'translateY(0)',
        ease: 'power1',
      },
      '<1'
    );
  }

  mobileAnimation() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.fancy-gallery__wrapper',
        pin: true,
        snap: 1 / (3 * 3 - 1),
        scrub: true,
        start: () => 'top ' + document.querySelector('header.header').clientHeight + 'px',
        end: '+=1500',
      },
    });

    tl.addLabel('phase1');
    tl.addLabel('phase2', 'phase1_content+=.5');

    tl.to(
      '.fancy-gallery__item.first',
      {
        '--first-factor': '0.1',
      },
      'phase1'
    )
      .to(
        '.fancy-gallery__item.main',
        {
          '--main-factor': '0.8',
        },
        'phase1'
      )
      .to(
        '.fancy-gallery__item.main .content-overlay',
        {
          opacity: 1,
          transform: 'translateY(0)',
        },
        'phase1'
      );

    tl.to(
      '.fancy-gallery__item.main',
      {
        '--main-factor': '0.1',
      },
      'phase2'
    )
      .to(
        '.fancy-gallery__item.last',
        {
          '--last-factor': '0.8',
        },
        'phase2'
      )
      .to(
        '.fancy-gallery__item.last .content-overlay',
        {
          opacity: 1,
          transform: 'translateY(0)',
        },
        'phase2'
      );
  }
}

if (!customElements.get('fancy-gallery')) {
  customElements.define('fancy-gallery', FancyGallery);
}


})();